import { AppButton } from '@components/AppComponents'
import { TableFilterContext } from '@components/table/TableContext'
import { Card, Form } from 'antd'
import cx from 'classnames'
import React, { useContext, useEffect, useMemo, useState } from 'react'

interface Props {
  children: React.ReactNode
  maxColumns?: number
}

const FilterSection = ({ children, maxColumns = 4 }: Props) => {
  const filterContext = useContext(TableFilterContext)
  const [form] = Form.useForm()

  const [isMounted, setIsMounted] = useState(false)

  const classNames = useMemo(() => {
    if (maxColumns == 4) {
      return 'grid gap-x-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
    }

    if (maxColumns == 3) {
      return 'grid gap-x-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3'
    }

    if (maxColumns == 2) {
      return 'grid gap-x-4 grid-cols-1 sm:grid-cols-2'
    }
  }, [maxColumns])

  const handleApply = (values: any) => {
    filterContext.handleSearch?.()
    handleClose()
  }

  const handleClose = () => {
    filterContext.setShowFilterSection(false)
  }

  const handleReset = () => {
    filterContext.handleReset?.()
    // handleClose()
  }

  useEffect(() => {
    if (filterContext.isShowFilterSection && !isMounted) {
      setIsMounted(true)
    }
  }, [filterContext.isShowFilterSection])

  if (!filterContext.isShowFilterSection && !isMounted) {
    return null
  }

  return (
    <div
      className={cx({
        'absolute top-50 left-0 right-0 z-50 animate-fadeIn ':
          !filterContext.showFilterInPlace,
        hidden: !filterContext.isShowFilterSection,
      })}
    >
      <Card
        className={cx([
          'relative rounded-lg border border-grey-200 shadow-lg pb-0 max-h-[calc(100vh-200px)] overflow-auto',
        ])}
      >
        <Form layout="vertical">
          <div className={classNames}>{children}</div>
        </Form>
        {!filterContext.showFilterInPlace && (
          <div className="flex gap-2 justify-center border-t border-grey-200 pt-4 bottom-4 sticky left-0 right-0 bg-white">
            <AppButton color="blue" onClick={handleApply}>
              Apply
            </AppButton>
            <AppButton color="red" onClick={handleReset}>
              Clear All Filters
            </AppButton>
            <AppButton color="default" onClick={handleClose}>
              Close
            </AppButton>
          </div>
        )}
      </Card>
    </div>
  )
}

export default FilterSection
